import React from 'react'
import OrgTable from './component/Org-table'

const Index = () => {
  return (
    <>
    <OrgTable/>
    </>
  )
}

export default Index